import React from 'react'
import { SvgIcon } from '../svg-icon'
/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.DefaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}
/**
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <WeatherCloudThunderIcon width={12} />
 */
export const WeatherCloudThunderIcon = props => (
    <SvgIcon {...props}>
        <path d="M11.85 26.4L14.76 23.1L12.36 21.9L15.75 18H18.15L15.24 21.3L17.64 22.5L14.25 26.4H11.85ZM4.65 26.4L7.56 23.1L5.16 21.9L8.55 18H10.95L8.04 21.3L10.44 22.5L7.05 26.4H4.65ZM6.3 16.2C4.56272 16.2 3.0784 15.5848 1.84704 14.3544C0.61568 13.124 0 11.6409 0 9.90495C0 8.32165 0.565 6.91 1.695 5.67C2.825 4.43 4.23 3.75 5.91 3.63C6.55 2.51 7.395 1.625 8.445 0.975C9.495 0.325 10.6842 0 12.0127 0C13.8242 0 15.345 0.575 16.575 1.725C17.805 2.875 18.56 4.3 18.84 6C20.42 6.08 21.675 6.615 22.605 7.605C23.535 8.595 24 9.75623 24 11.0887C24 12.4962 23.5042 13.7 22.5125 14.7C21.5208 15.7 20.3167 16.2 18.9 16.2H6.3ZM6.3 14.4H18.9C19.824 14.4 20.605 14.075 21.243 13.425C21.881 12.775 22.2 11.995 22.2 11.085C22.2 10.175 21.881 9.4 21.243 8.76C20.605 8.12 19.824 7.8 18.9 7.8H17.1V6.9C17.1 5.48 16.605 4.275 15.615 3.285C14.625 2.295 13.4221 1.8 12.0064 1.8C10.9767 1.8 10.0383 2.075 9.19095 2.625C8.34365 3.175 7.72 3.92 7.32 4.86L7.08 5.4H6.24C5 5.44 3.95 5.89393 3.09 6.76179C2.23 7.62965 1.8 8.67429 1.8 9.89571C1.8 11.1386 2.23929 12.2 3.11787 13.08C3.99643 13.96 5.05714 14.4 6.3 14.4Z" />
    </SvgIcon>
)

WeatherCloudThunderIcon.defaultProps = defaultProps
